import { useQuery } from '@tanstack/vue-query';

import { getParkingSpaces } from '@/api/basecamp.api';

export const useParkingSpaces = (estateId: number) => {
    return useQuery(['parkingSpaces', estateId], async () => getParkingSpaces(estateId), {
        initialData: [],
    });
};
